var SENTRY_RELEASE;SENTRY_RELEASE={name: "my actual", version: "1.25.0"};